/* Hero — Hund/Katze Selector. Morphing toggle, pure vanilla + CSS transitions.
   Reads per-mode data from the toggle buttons (data-* injected by Liquid),
   crossfades the matching media, and re-triggers the text morph on switch.
   Multiple instances supported. */
(function () {
  function initHero(root) {
    var toggle = root.querySelector('.hps__toggle');
    var thumb  = root.querySelector('.hps__thumb');
    var btns   = Array.prototype.slice.call(root.querySelectorAll('.hps__toggle button'));
    var heading = root.querySelector('.hps__heading');
    var sub     = root.querySelector('.hps__sub');
    var cta     = root.querySelector('.hps__cta');
    var ctaLabel = cta ? cta.querySelector('.hps__cta-label') : null;
    var medias  = Array.prototype.slice.call(root.querySelectorAll('.hps__media'));
    if (!btns.length) return;

    function placeThumb(btn) {
      if (!thumb || !btn) return;
      thumb.style.left = btn.offsetLeft + 'px';
      thumb.style.width = btn.offsetWidth + 'px';
    }

    var morphTimer = null;
    function activate(idx, animate) {
      var btn = btns[idx];
      if (!btn) return;
      var d = btn.dataset;

      btns.forEach(function (b, i) {
        b.setAttribute('aria-selected', i === idx ? 'true' : 'false');
      });
      placeThumb(btn);
      if (d.accent) root.style.setProperty('--accent', d.accent);

      // crossfade media
      medias.forEach(function (m) {
        if (parseInt(m.dataset.idx, 10) === idx) m.setAttribute('data-active', '');
        else m.removeAttribute('data-active');
      });

      var apply = function () {
        // Build heading safely (no innerHTML): "|" in the setting = line break.
        if (d.heading != null && heading) {
          heading.textContent = '';
          d.heading.split('|').forEach(function (line, i) {
            if (i) heading.appendChild(document.createElement('br'));
            heading.appendChild(document.createTextNode(line));
          });
        }
        if (d.sub != null && sub) sub.textContent = d.sub;
        if (ctaLabel && d.ctaLabel != null) ctaLabel.textContent = d.ctaLabel;
        if (cta && d.ctaLink) cta.setAttribute('href', d.ctaLink);
      };

      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches
                || root.getAttribute('data-animate') === 'false';
      if (!animate || reduce) { apply(); root.classList.remove('is-morphing'); return; }

      // re-trigger text morph: fade out -> swap -> fade in
      root.classList.add('is-morphing');
      clearTimeout(morphTimer);
      morphTimer = setTimeout(function () {
        apply();
        // next frame: remove class so CSS transitions back to visible
        requestAnimationFrame(function () { root.classList.remove('is-morphing'); });
      }, 230);
    }

    btns.forEach(function (b, i) {
      b.addEventListener('click', function () { activate(i, true); });
    });

    // init to default (button already marked aria-selected by Liquid, else 0)
    var startIdx = Math.max(0, btns.findIndex(function (b) { return b.getAttribute('aria-selected') === 'true'; }));
    // place thumb once layout is ready (fonts/images)
    function settle() { activate(startIdx, false); }
    if (document.readyState === 'complete') settle();
    else window.addEventListener('load', settle);
    settle();

    // recompute thumb on resize (breakpoint/layout changes)
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () {
        var active = btns.find(function (b) { return b.getAttribute('aria-selected') === 'true'; }) || btns[0];
        placeThumb(active);
      }, 120);
    });
  }

  function boot() {
    document.querySelectorAll('[data-hps]').forEach(initHero);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
